<template>
  <FlexColumn space="half">
    <Label text="経験のある職種" class="mb-1" bold />
    <SimpleSelectField
        :value="value"
        :items="items"
        multiple
        class="mt-0 pt-0"
        @input="handleInput"
    />
  </FlexColumn>
</template>

<script>
import SimpleSelectField from "@/components/atoms/SimpleSelectField";
import {mapGetters} from "vuex";
import Label from '../atoms/Label'
import FlexColumn from '../atoms/FlexColumn'

export default {
  name: "ApplicantSearchPositionSelect",
  components: { FlexColumn, Label, SimpleSelectField},
  props: {
    value: {
      type: Array
    }
  },
  computed: {
    ...mapGetters('system', ['consts']),
    items() {
      if (this.consts.currentJob) {
        return this.consts.currentJob.map(item => ({value: item.value, label: item.label[0]}))
      }
      return []
    }
  },
  methods: {
    handleInput(value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style scoped>

</style>